import { Fieldset } from "@/react/components/shared/uikit/Fieldset";
import { useBillingCycleState } from "@/react/hooks/useBillingCycleState";
import { planIntervals } from "@circle-react/helpers/plansHelpers";
import { useAuxiliaryPlans } from "../../../hooks/useAuxiliaryPlans";
import { AnnualRadioOption } from "./AnnualRadioOption";
import { MonthlyRadioOption } from "./MonthlyRadioOption";

export const BillingIntervalRadio = () => {
  const { isYearly, shouldShowBillingCycleOptions, handleIntervalChange } =
    useBillingCycleState();
  const { areBothIntervalsLoaded, monthlyPlan, yearlyPlan } =
    useAuxiliaryPlans();

  if (!shouldShowBillingCycleOptions || !areBothIntervalsLoaded) {
    return null;
  }

  return (
    <Fieldset legend="Billing Cycle">
      <AnnualRadioOption
        id="annual-billing"
        interval={planIntervals.year}
        isSelected={isYearly}
        plan={yearlyPlan}
        onIntervalChange={handleIntervalChange}
      />
      <MonthlyRadioOption
        id="monthly-billing"
        interval={planIntervals.month}
        isSelected={!isYearly}
        plan={monthlyPlan}
        onIntervalChange={handleIntervalChange}
      />
    </Fieldset>
  );
};

BillingIntervalRadio.displayName = "BillingIntervalRadio";
